/**
 * Lightweight Event Tracking for Shop Rituals Collection Page
 * Tracks ritual card clicks and quiz CTA clicks
 * Scoped to collection.shop-rituals template only
 */

(function() {
  'use strict';
  
  // Only run on Shop Rituals collection page
  const selector = document.querySelector('.veluna-ritual-primary-selector');
  if (!selector) {
    return;
  }
  
  // Helper: Dispatch custom event and push to dataLayer if available
  function trackEvent(eventName, payload) {
    // Dispatch CustomEvent
    try {
      window.dispatchEvent(new CustomEvent(eventName, {
        detail: payload,
        bubbles: true,
        cancelable: true
      }));
    } catch (e) {
      console.warn('[Veluna Tracking] Failed to dispatch CustomEvent:', e);
    }
    
    // Push to dataLayer if available (for GA/GTAG)
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      try {
        window.dataLayer.push({
          event: eventName,
          ...payload
        });
      } catch (e) {
        console.warn('[Veluna Tracking] Failed to push to dataLayer:', e);
      }
    }
  }
  
  // Track ritual card clicks
  function handleRitualCardClick(event) {
    const card = event.currentTarget;
    const ritualHandle = card.getAttribute('data-ritual') || '';
    const ritualTitle = card.querySelector('.veluna-ritual-primary-selector__card-title')?.textContent?.trim() || '';
    const href = card.getAttribute('href') || '';
    
    trackEvent('veluna_ritual_card_click', {
      ritual_handle: ritualHandle,
      ritual_title: ritualTitle,
      href: href,
      page_type: 'collection_shop_rituals'
    });
  }
  
  // Track quiz CTA clicks
  function handleQuizClick(event) {
    const link = event.currentTarget;
    const href = link.getAttribute('href') || '';
    
    trackEvent('veluna_ritual_quiz_click', {
      href: href,
      location: 'ritual_primary_selector',
      page_type: 'collection_shop_rituals'
    });
  }
  
  // Track quiz hero impressions (optional, fail-safe)
  function trackQuizHeroImpression() {
    // Only run if IntersectionObserver is available
    if (!('IntersectionObserver' in window)) {
      return;
    }
    
    const quizHero = selector.querySelector('[data-quiz-hero-impression]');
    if (!quizHero) {
      return; // Quiz hero not present (quiz-first not enabled or quiz_url blank)
    }
    
    // Track impression once when hero enters viewport
    let hasTracked = false;
    const observer = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && !hasTracked) {
            hasTracked = true;
            trackEvent('veluna_ritual_quiz_hero_view', {
              location: 'ritual_primary_selector',
              page_type: 'collection_shop_rituals'
            });
            observer.disconnect(); // Stop observing after first view
          }
        });
      },
      {
        threshold: 0.25, // Fire when 25% visible
        rootMargin: '0px'
      }
    );
    
    try {
      observer.observe(quizHero);
    } catch (e) {
      // Fail silently if observer fails
      console.warn('[Veluna Tracking] Quiz hero impression tracking failed:', e);
    }
  }
  
  // Initialize tracking with event delegation
  function initTracking() {
    // Find all ritual cards within the selector
    const ritualCards = selector.querySelectorAll('.veluna-ritual-primary-selector__card[data-ritual]');
    ritualCards.forEach(function(card) {
      card.addEventListener('click', handleRitualCardClick, { passive: true });
    });
    
    // Find quiz CTA
    const quizCTA = selector.querySelector('.veluna-ritual-primary-selector__quiz-cta');
    if (quizCTA) {
      quizCTA.addEventListener('click', handleQuizClick, { passive: true });
    }
    
    // Track quiz hero impressions (optional)
    trackQuizHeroImpression();
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTracking);
  } else {
    initTracking();
  }
})();

